import { useState } from 'react'
import { ActionIcon, Button, Popover, TextInput } from '@mantine/core'
import { IconPlus } from '@tabler/icons-react'
import { useBoardMutations, type Board } from './hooks'

// Trailing "+" header cell: adds a text column to the board.
export const AddColumnControl = ({ board }: { board: Board }) => {
  const [opened, setOpened] = useState(false)
  const [label, setLabel] = useState('')
  const { addColumn } = useBoardMutations(board.id)

  const submit = async () => {
    const name = label.trim()
    if (!name || addColumn.isPending) return
    try {
      await addColumn.mutateAsync({ id: board.id, label: name })
      setLabel('')
      setOpened(false)
    } catch {
      // Error notification handled by the mutation hook.
    }
  }

  return (
    <Popover opened={opened} onChange={setOpened} position="bottom-end" shadow="md" withinPortal>
      <Popover.Target>
        <ActionIcon
          variant="subtle"
          color="gray"
          size="sm"
          aria-label="Add column"
          onClick={() => setOpened((prev) => !prev)}
        >
          <IconPlus size={14} />
        </ActionIcon>
      </Popover.Target>
      <Popover.Dropdown className="w-56">
        <TextInput
          autoFocus
          size="xs"
          label="New text column"
          placeholder="Column name"
          value={label}
          onChange={(e) => setLabel(e.currentTarget.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') void submit()
            if (e.key === 'Escape') setOpened(false)
          }}
        />
        <Button
          size="xs"
          fullWidth
          className="mt-2"
          loading={addColumn.isPending}
          disabled={!label.trim()}
          onClick={() => void submit()}
        >
          Add column
        </Button>
      </Popover.Dropdown>
    </Popover>
  )
}
